import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { withTheme } from 'react-fela'
import { connect } from 'react-redux'
import Header from 'views/layouts/Header'
import Footer from 'views/layouts/Footer'
import { ToastContainer } from 'views/layouts/Toast/ToastContainer'
import routes from 'routes'
import { customPageRoutes, previewRoutes, publicLandingPageRoutes } from 'routes/customPageRoutes'
import Loader from 'views/components/presentationals/atoms/Spinner/Loader'
import Spinner from 'views/components/presentationals/atoms/Spinner/Spinner'
import MessageHeader from 'views/components/smart/MessageHeader'
import Heartbeat from '../../components/smart/Heartbeat'
import Notification from 'views/components/smart/Notification'
import BackgroundActivities from '../../components/smart/BackgroundActivities'
import TemporaryMessage from 'views/components/smart/TemporaryMessage'
import PropTypes from 'prop-types'
import { CustomPageContextProvider } from 'views/context/useCustomPageContext'
import { Spin } from 'antd'
import { isHostNameMainDomain } from 'utils/customPage'

const mapStateToProps = (state) => ({
  ready: state.app.ready,
})

const App = ({ ready }) => {
  Spin.setDefaultIndicator(<Loader />)

  if (!ready) {
    return <Spinner height={'100vh'} />
  }

  if (isHostNameMainDomain()) {
    return <CustomPageApp />
  }
  return (
    <Switch>
      <Route path={'/landing'} name="PublicLandingPageApp" exact={false} component={PublicLandingPageApp} />
      <Route path={'/preview'} name="PreviewApp" exact={false} component={PreviewApp} />
      <Route path={'/'} name="MainApp" exact={false} component={MainApp} />
    </Switch>
  )
}

const PreviewApp = () => {
  return (
    <main style={{ height: '100%' }}>
      {previewRoutes.map((route) => (
        <Route key={route.path} {...route} />
      ))}
    </main>
  )
}

const MainApp = () => {
  return (
    <>
      <Header />
      <MessageHeader />
      <TemporaryMessage />
      <ToastContainer />
      <main>
        {routes.map((route) => (
          <Route key={route.path} {...route} />
        ))}
      </main>
      <Footer />
      <Heartbeat />
      <BackgroundActivities />
      <Notification />
    </>
  )
}

const CustomPageApp = () => {
  return (
    <>
      <CustomPageContextProvider>
        <ToastContainer />
        <main style={{ dislay: 'flex', flex: 1 }}>
          {customPageRoutes.map((route) => (
            <Route key={route.path} {...route} />
          ))}
        </main>
      </CustomPageContextProvider>
    </>
  )
}

const PublicLandingPageApp = () => {
  return (
    <>
      <ToastContainer />
      <main style={{ minHeight: '100vh' }}>
        {publicLandingPageRoutes.map((route) => (
          <Route key={route.path} {...route} />
        ))}
      </main>
    </>
  )
}

App.propTypes = {
  ready: PropTypes.bool,
}

export default connect(mapStateToProps, () => ({}), null, { pure: false })(withTheme(App))
